import {Outlet} from 'react-router-dom'
import {Footer} from './footer/Footer'
import {ThemeModeProvider} from '../../_metronic/partials'
import {HeaderWrapper} from './header/HeaderWrapper'

export const PageWrapper = () => {
  return (
    <div className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'>
      <ThemeModeProvider>
        <HeaderWrapper />
        <Outlet />
        <Footer />
      </ThemeModeProvider>
    </div>
  )
}
